module.exports = __webpack_public_path__ + "static/brandbox-pricingBG-agency-aa9440c3265236494f2507dfd6defbf6.png";